import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ standalone: true, name: 'booleanToIconString' })
export class BooleanToStringIconPipe implements PipeTransform {
    transform(state: boolean): string {
        return booleanToIconString(state);
    }
}

export function booleanToIcon(state: boolean): string {
    return state ? 'check' : 'close';
}

export function booleanToIconString(state: boolean): string {
    return state ? '✓' : '✕';
}
